// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.root__STiP0Hl8dP{display:flex;flex-direction:column;height:100%;container-type:inline-size}`, "",{"version":3,"sources":["webpack://./src/app/views/layout/views/dashboard/views/channel/channelDashboard.view.module.scss"],"names":[],"mappings":"AAAA,kBACE,YAAA,CACA,qBAAA,CACA,WAAA,CACA,0BAAA","sourcesContent":[".root {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  container-type: inline-size;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `root__STiP0Hl8dP`
};
export default ___CSS_LOADER_EXPORT___;
